// This will be removed when backend is ready
import { MediaType, type MediaFile, type MediaProps, type TabName } from '../types/common.types';

const productTabs = {
  'TRIAL MANAGER': {
    label: 'TRIAL MANAGER',
    productcode: 'trialmax',
    folder: 'trial-manager',
    enabled: true,
    files: [
      {
        fileType: 'text',
        url: '',
        title: 'Trial Manager Documentation',
        description: 'Comprehensive documentation of the Trial Manager system',
        content:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      },
    ],
  },
  APP: {
    label: 'APP',
    productcode: 'trialmax',
    folder: 'app',
    enabled: true,
    files: [
      {
        fileType: 'image',
        url: '/media/trialmax/app/interface-screenshot.png',
        title: 'TrialMax App Interface',
        description: 'Visual guide of the mobile app interface',
      },
      {
        fileType: 'video',
        url: '/media/trialmax/touch/guide.mp4',
        title: 'Touch Interface Guide',
        description: 'Guide to using the touch interface features',
        duration: '00:01:00',
      },
    ],
  },
  TOUCH: {
    label: 'TOUCH',
    productcode: 'trialmax',
    folder: 'touch',
    enabled: true,
    files: [
      {
        fileType: 'video',
        url: '/media/trialmax/touch/guide.mp4',
        title: 'Touch Interface Guide',
        description: 'Guide to using the touch interface features',
        duration: '00:01:00',
      },
    ],
  },
  SLATE: {
    label: 'SLATE',
    productcode: 'trialmax',
    folder: 'slate',
    enabled: true,
    files: [
      {
        fileType: 'pdf',
        url: './assets/test.pdf',
        title: 'Slate Device Manual',
        description: 'Comprehensive manual for slate device configuration',
      },
      {
        fileType: 'pdf',
        url: './assets/samplePdfFile.pdf',
        title: 'Slate Device setting',
        description: 'Slate device configuration',
      },
    ],
  },
  WEB: {
    label: 'WEB',
    productcode: 'trialmax',
    folder: 'web',
    enabled: true,
    files: [
      {
        fileType: 'image',
        url: '/media/trialmax/web/portal-screens.png',
        title: 'Web Portal Screenshots',
        description: 'Key features of the web portal interface',
      },
    ],
  },
  LOGISTICS: {
    label: 'LOGISTICS',
    productcode: 'trialmax',
    folder: 'logistics',
    enabled: true,
    files: [
      {
        fileType: 'image',
        url: '/media/trialmax/web/portal-screens.png',
        title: 'Web Portal Screenshots',
        description: 'Key features of the web portal interface',
      },
      {
        fileType: 'text',
        url: '',
        title: 'Logistics Quick Guide',
        description: 'Quick reference guide for logistics management',
        content:
          'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      },
    ],
  },
  'DEVICE MANAGER': {
    label: 'DEVICE MANAGER',
    productcode: 'trialmax',
    folder: 'device-manager',
    enabled: true,
    files: [
      {
        fileType: 'image',
        url: '/media/trialmax/device-manager/dashboard.png',
        title: 'Device Management Dashboard',
        description: 'Overview of the device management interface',
      },
    ],
  },
  'STUDYIQ VIDEOS': {
    label: 'STUDYIQ VIDEOS',
    productcode: 'trialmax',
    folder: 'studyiq-videos',
    enabled: true,
    files: [
      {
        fileType: 'pdf',
        url: './samplePdfFile.pdf',
        title: 'StudyIQ Documentation',
        description: 'Complete documentation of StudyIQ features',
      },
      {
        fileType: 'image',
        url: '/media/trialmax/web/portal-screens.png',
        title: 'Web Portal Screenshots',
        description: 'Key features of the web portal interface',
      },
    ],
  },
  CLIENT: {
    label: 'CLIENT',
    productcode: 'raterstation',
    folder: 'client',
    enabled: true,
    files: [
      {
        fileType: 'text',
        url: '',
        title: 'Client Interface Guide',
        description: 'Comprehensive guide to the client interface',
        content:
          'Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur.',
      },
    ],
  },
  COLLECTOR: {
    label: 'COLLECTOR',
    productcode: 'raterstation',
    folder: 'collector',
    enabled: true,
    files: [
      {
        fileType: 'image',
        url: '/media/rater-station/collector/interface.png',
        title: 'Data Collector Interface',
        description: 'Visual guide to data collection tools',
      },
    ],
  },
};

export const getMediaFilesForTab = (tabName: TabName): MediaFile[] => {
  return productTabs[tabName]?.files || [];
};

export const getGroupedFilesByType = (tabName: TabName) => {
  const files = productTabs[tabName]?.files || [];

  return files.reduce(
    (
      acc: { mediaFiles: Record<string, MediaProps[]>; textFiles: MediaFile[] },
      file: MediaFile
    ) => {
      if (file.fileType === MediaType.Text) {
        acc.textFiles.push(file);
      } else {
        acc.mediaFiles[file.fileType].push({
          name: `[Mocked] ${file.title}`,
          createdDate: new Date().toISOString(),
          url: file.url,
          ...(file.fileType === MediaType.Video
            ? {
                duration: file.duration,
              }
            : {}),
        });
      }
      return acc;
    },
    {
      mediaFiles: {
        [MediaType.Image]: [],
        [MediaType.Audio]: [],
        [MediaType.Video]: [],
        [MediaType.Pdf]: [],
      },
      textFiles: [],
    }
  );
};
